import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const PlusSolid = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 20 20'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path d='M10.75 6.75C10.75 6.55109 10.671 6.36032 10.5303 6.21967C10.3897 6.07902 10.1989 6 10 6C9.80109 6 9.61032 6.07902 9.46967 6.21967C9.32902 6.36032 9.25 6.55109 9.25 6.75V9.25H6.75C6.55109 9.25 6.36032 9.32902 6.21967 9.46967C6.07902 9.61032 6 9.80109 6 10C6 10.1989 6.07902 10.3897 6.21967 10.5303C6.36032 10.671 6.55109 10.75 6.75 10.75H9.25V13.25C9.25 13.4489 9.32902 13.6397 9.46967 13.7803C9.61032 13.921 9.80109 14 10 14C10.1989 14 10.3897 13.921 10.5303 13.7803C10.671 13.6397 10.75 13.4489 10.75 13.25V10.75H13.25C13.4489 10.75 13.6397 10.671 13.7803 10.5303C13.921 10.3897 14 10.1989 14 10C14 9.80109 13.921 9.61032 13.7803 9.46967C13.6397 9.32902 13.4489 9.25 13.25 9.25H10.75V6.75Z' />
    </svg>
  );
};
